module.exports = __webpack_public_path__ + "static/chocolate-bowl-2-586c0ec62355e80349eadcc3c2bb168c.jpg";